var map = {
	"./animated/loader.svg": 35019,
	"./arrow-bottom-right.svg": 46456,
	"./arrow-down-2.svg": 77393,
	"./arrow-down.svg": 82956,
	"./arrow-left.svg": 38843,
	"./arrow-right.svg": 81182,
	"./arrow-up-2.svg": 51557,
	"./arrow-up-right.svg": 6942,
	"./arrow-up.svg": 85831,
	"./at-sign.svg": 16343,
	"./bell.svg": 63543,
	"./book.svg": 12571,
	"./btn_play.svg": 7261,
	"./calendar-4days.svg": 27116,
	"./calendar-list.svg": 67443,
	"./calendar-month.svg": 67399,
	"./calendar-oval-2.svg": 38834,
	"./calendar-oval.svg": 39,
	"./calendar-today.svg": 17538,
	"./calendar-week.svg": 98943,
	"./calendar.svg": 19966,
	"./carousel.svg": 59682,
	"./categories-list.svg": 19069,
	"./check-circle-large.svg": 52255,
	"./check-circle.svg": 94097,
	"./check-filled.svg": 34905,
	"./check-small.svg": 43462,
	"./check-square.svg": 40660,
	"./check.svg": 95044,
	"./checkbox-selected.svg": 47619,
	"./checkbox.svg": 96455,
	"./chevron-down-small.svg": 2776,
	"./chevron-down.svg": 11474,
	"./chevron-left-small.svg": 64299,
	"./chevron-left.svg": 48057,
	"./chevron-right-small.svg": 57145,
	"./chevron-right.svg": 83364,
	"./chevron-up-small.svg": 21171,
	"./chevron-up.svg": 74721,
	"./clock.svg": 13990,
	"./close-square.svg": 18160,
	"./close.svg": 99888,
	"./copy.svg": 97003,
	"./corner-up-right.svg": 37922,
	"./credit-card.svg": 19438,
	"./deals.svg": 7081,
	"./document-text.svg": 85877,
	"./download-small.svg": 50294,
	"./download.svg": 34804,
	"./drag.svg": 80282,
	"./duotone/bot.svg": 89466,
	"./duotone/chat.svg": 70249,
	"./edit.svg": 43288,
	"./editor.svg": 39551,
	"./external-link.svg": 4086,
	"./eye-off.svg": 61547,
	"./eye.svg": 97219,
	"./facebook-disconnected.svg": 36996,
	"./facebook-f.svg": 65153,
	"./facebook-flat.svg": 50016,
	"./facebook-outlined.svg": 42223,
	"./file-plus.svg": 38495,
	"./file-text.svg": 38890,
	"./film.svg": 81982,
	"./folder-plus.svg": 49873,
	"./globe.svg": 87179,
	"./grid-plus.svg": 40005,
	"./grid.svg": 70492,
	"./header-filter.svg": 52026,
	"./heart.svg": 41456,
	"./home-2.svg": 2288,
	"./home.svg": 32409,
	"./icon_add_small.svg": 93655,
	"./image.svg": 64131,
	"./info-small.svg": 62194,
	"./insights.svg": 58179,
	"./instagram-disconnected.svg": 69756,
	"./instagram-flat.svg": 52648,
	"./instagram.svg": 95032,
	"./key-cmd.svg": 96822,
	"./key-win.svg": 12724,
	"./key.svg": 71353,
	"./life-buoy.svg": 18008,
	"./link-2.svg": 51809,
	"./link.svg": 25660,
	"./live-video.svg": 34448,
	"./lock-square.svg": 98099,
	"./lock.svg": 73953,
	"./mail.svg": 8017,
	"./map-pin-plus.svg": 18389,
	"./map-pin.svg": 36236,
	"./maximize.svg": 65562,
	"./media.svg": 59360,
	"./menu-2.svg": 55624,
	"./menu.svg": 59425,
	"./message-circle.svg": 24070,
	"./message-dots.svg": 89338,
	"./message-square.svg": 18811,
	"./message-text.svg": 98771,
	"./minus.svg": 18292,
	"./more-horizontal.svg": 18712,
	"./mouse-arrow.svg": 60217,
	"./new-bag-outline.svg": 24126,
	"./new-bag-solid.svg": 64265,
	"./new-bars-outline.svg": 40908,
	"./new-bars-solid.svg": 96495,
	"./new-box-outline.svg": 63887,
	"./new-box-solid.svg": 66588,
	"./new-calendar-outline.svg": 77368,
	"./new-calendar-solid.svg": 44467,
	"./new-content-outline.svg": 10943,
	"./new-content-solid.svg": 19756,
	"./new-drop-outline.svg": 17589,
	"./new-drop-solid.svg": 1610,
	"./new-edit-outline.svg": 48350,
	"./new-groups-outline.svg": 47378,
	"./new-groups-solid.svg": 52613,
	"./new-help-outline.svg": 70343,
	"./new-help-solid.svg": 60484,
	"./new-layout-outline.svg": 60792,
	"./new-link-outlined.svg": 35174,
	"./new-pin-outline.svg": 90477,
	"./new-pin-solid.svg": 45682,
	"./new-repeat-outline.svg": 17783,
	"./new-shuffle-outline.svg": 38963,
	"./new-users-solid.svg": 46135,
	"./new-video-solid.svg": 57066,
	"./order-list.svg": 6257,
	"./passkey.svg": 38508,
	"./pen-edit.svg": 5262,
	"./phone.svg": 71368,
	"./play-circle.svg": 83103,
	"./play.svg": 33490,
	"./plus-circle.svg": 70889,
	"./plus-square.svg": 11052,
	"./plus.svg": 17724,
	"./po-logo.svg": 16217,
	"./pointer-click.svg": 88992,
	"./power.svg": 8079,
	"./question-circle.svg": 80413,
	"./radio.svg": 28709,
	"./refresh.svg": 67269,
	"./repeat.svg": 67809,
	"./report-active.svg": 80649,
	"./report.svg": 97146,
	"./rotate-cw.svg": 23052,
	"./sales-empty.svg": 89744,
	"./save.svg": 48899,
	"./search.svg": 63568,
	"./server-horizontal.svg": 56278,
	"./server-vertical.svg": 59948,
	"./settings.svg": 28523,
	"./shield.svg": 38647,
	"./shopping-bag.svg": 91917,
	"./shopping-cart.svg": 80755,
	"./sliders-2.svg": 92683,
	"./sliders-3.svg": 98810,
	"./smiley.svg": 62137,
	"./snack-error.svg": 47383,
	"./snack-facebook.svg": 1503,
	"./snack-info.svg": 79227,
	"./snack-information.svg": 41843,
	"./snack-internet.svg": 4944,
	"./snack-share.svg": 89212,
	"./snack-success.svg": 21772,
	"./snack-warning.svg": 7913,
	"./social/facebook.svg": 64052,
	"./social/instagram.svg": 47268,
	"./social/linkedin.svg": 87918,
	"./social/pinterest.svg": 28614,
	"./social/twitter.svg": 35013,
	"./social/youtube.svg": 28987,
	"./svg/arrow-bottom-right.svg": 57197,
	"./svg/arrow-down-2.svg": 7620,
	"./svg/arrow-down.svg": 16021,
	"./svg/arrow-left.svg": 9742,
	"./svg/arrow-right.svg": 57261,
	"./svg/arrow-up-2.svg": 26395,
	"./svg/arrow-up-right.svg": 36107,
	"./svg/arrow-up.svg": 53306,
	"./svg/at-sign.svg": 66252,
	"./svg/bell.svg": 79194,
	"./svg/book.svg": 82030,
	"./svg/btn_play.svg": 60520,
	"./svg/calendar-4days.svg": 29365,
	"./svg/calendar-list.svg": 52528,
	"./svg/calendar-month.svg": 78114,
	"./svg/calendar-oval-2.svg": 61633,
	"./svg/calendar-oval.svg": 32796,
	"./svg/calendar-today.svg": 25107,
	"./svg/calendar-week.svg": 30372,
	"./svg/calendar.svg": 51407,
	"./svg/carousel.svg": 99335,
	"./svg/categories-list.svg": 77306,
	"./svg/check-circle-large.svg": 99278,
	"./svg/check-circle.svg": 13280,
	"./svg/check-filled.svg": 91900,
	"./svg/check-small.svg": 75761,
	"./svg/check-square.svg": 25481,
	"./svg/check.svg": 19011,
	"./svg/checkbox-selected.svg": 31808,
	"./svg/checkbox.svg": 32098,
	"./svg/chevron-down-small.svg": 93229,
	"./svg/chevron-down.svg": 99663,
	"./svg/chevron-left-small.svg": 43122,
	"./svg/chevron-left.svg": 90480,
	"./svg/chevron-right-small.svg": 90141,
	"./svg/chevron-right.svg": 66047,
	"./svg/chevron-up-small.svg": 2498,
	"./svg/chevron-up.svg": 6464,
	"./svg/clock.svg": 68481,
	"./svg/close-square.svg": 89021,
	"./svg/close.svg": 51319,
	"./svg/copy.svg": 32722,
	"./svg/corner-up-right.svg": 90597,
	"./svg/credit-card.svg": 78209,
	"./svg/deals.svg": 35962,
	"./svg/document-text.svg": 13730,
	"./svg/download-small.svg": 27139,
	"./svg/download.svg": 49457,
	"./svg/drag.svg": 63183,
	"./svg/edit.svg": 92041,
	"./svg/editor.svg": 43414,
	"./svg/external-link.svg": 9333,
	"./svg/eye-off.svg": 99068,
	"./svg/eye.svg": 62904,
	"./svg/facebook-disconnected.svg": 78695,
	"./svg/facebook-f.svg": 7828,
	"./svg/facebook-flat.svg": 22311,
	"./svg/facebook-outlined.svg": 23744,
	"./svg/file-plus.svg": 46764,
	"./svg/file-text.svg": 38233,
	"./svg/film.svg": 44587,
	"./svg/folder-plus.svg": 93626,
	"./svg/globe.svg": 95428,
	"./svg/grid-plus.svg": 20738,
	"./svg/grid.svg": 78025,
	"./svg/header-filter.svg": 49161,
	"./svg/heart.svg": 71991,
	"./svg/home-2.svg": 19793,
	"./svg/home.svg": 35756,
	"./svg/icon_add_small.svg": 37310,
	"./svg/image.svg": 85788,
	"./svg/info-small.svg": 79923,
	"./svg/insights.svg": 45030,
	"./svg/instagram-disconnected.svg": 64325,
	"./svg/instagram-flat.svg": 31393,
	"./svg/instagram.svg": 63923,
	"./svg/key-cmd.svg": 71493,
	"./svg/key-win.svg": 54559,
	"./svg/key.svg": 61114,
	"./svg/life-buoy.svg": 70043,
	"./svg/link-2.svg": 95344,
	"./svg/link.svg": 90969,
	"./svg/live-video.svg": 71777,
	"./svg/lock-square.svg": 96432,
	"./svg/lock.svg": 79728,
	"./svg/mail.svg": 91616,
	"./svg/map-pin-plus.svg": 79608,
	"./svg/map-pin.svg": 44207,
	"./svg/maximize.svg": 2687,
	"./svg/media.svg": 46035,
	"./svg/menu-2.svg": 41813,
	"./svg/menu.svg": 83160,
	"./svg/message-circle.svg": 32431,
	"./svg/message-dots.svg": 30711,
	"./svg/message-square.svg": 89438,
	"./svg/message-text.svg": 69918,
	"./svg/minus.svg": 97943,
	"./svg/more-horizontal.svg": 36987,
	"./svg/mouse-arrow.svg": 30186,
	"./svg/new-bag-outline.svg": 69881,
	"./svg/new-bag-solid.svg": 68374,
	"./svg/new-bars-outline.svg": 75621,
	"./svg/new-bars-solid.svg": 60250,
	"./svg/new-box-outline.svg": 76988,
	"./svg/new-box-solid.svg": 98495,
	"./svg/new-calendar-outline.svg": 2545,
	"./svg/new-calendar-solid.svg": 75774,
	"./svg/new-content-outline.svg": 94744,
	"./svg/new-content-solid.svg": 67827,
	"./svg/new-drop-outline.svg": 26036,
	"./svg/new-drop-solid.svg": 32391,
	"./svg/new-edit-outline.svg": 23615,
	"./svg/new-groups-outline.svg": 56091,
	"./svg/new-groups-solid.svg": 41312,
	"./svg/new-help-outline.svg": 12718,
	"./svg/new-help-solid.svg": 38425,
	"./svg/new-layout-outline.svg": 53737,
	"./svg/new-link-outlined.svg": 17309,
	"./svg/new-pin-outline.svg": 5450,
	"./svg/new-pin-solid.svg": 72173,
	"./svg/new-repeat-outline.svg": 1038,
	"./svg/new-shuffle-outline.svg": 32016,
	"./svg/new-users-solid.svg": 50784,
	"./svg/new-video-solid.svg": 99029,
	"./svg/order-list.svg": 98948,
	"./svg/passkey.svg": 22491,
	"./svg/pen-edit.svg": 73275,
	"./svg/phone.svg": 5631,
	"./svg/play-circle.svg": 24460,
	"./svg/play.svg": 71791,
	"./svg/plus-circle.svg": 86742,
	"./svg/plus-square.svg": 62635,
	"./svg/plus.svg": 6681,
	"./svg/po-logo.svg": 11258,
	"./svg/pointer-click.svg": 12007,
	"./svg/power.svg": 57464,
	"./svg/question-circle.svg": 89070,
	"./svg/radio.svg": 53982,
	"./svg/refresh.svg": 83846,
	"./svg/repeat.svg": 77920,
	"./svg/report-active.svg": 33226,
	"./svg/report.svg": 25299,
	"./svg/rotate-cw.svg": 41431,
	"./svg/sales-empty.svg": 36827,
	"./svg/save.svg": 93198,
	"./svg/search.svg": 28533,
	"./svg/server-horizontal.svg": 62825,
	"./svg/server-vertical.svg": 87295,
	"./svg/settings.svg": 81462,
	"./svg/shield.svg": 75602,
	"./svg/shopping-bag.svg": 51216,
	"./svg/shopping-cart.svg": 50724,
	"./svg/sliders-2.svg": 68180,
	"./svg/sliders-3.svg": 13109,
	"./svg/smiley.svg": 90608,
	"./svg/snack-error.svg": 42740,
	"./svg/snack-facebook.svg": 18546,
	"./svg/snack-info.svg": 1062,
	"./svg/snack-information.svg": 5636,
	"./svg/snack-internet.svg": 62513,
	"./svg/snack-share.svg": 79267,
	"./svg/snack-success.svg": 14831,
	"./svg/snack-warning.svg": 86074,
	"./svg/tag-double.svg": 60551,
	"./svg/tag.svg": 6087,
	"./svg/thumbs-up.svg": 74688,
	"./svg/trash.svg": 85105,
	"./svg/type.svg": 41901,
	"./svg/upload-cloud.svg": 77594,
	"./svg/upload.svg": 4646,
	"./svg/user-check.svg": 4103,
	"./svg/user-minus.svg": 28155,
	"./svg/user-plus.svg": 63373,
	"./svg/user.svg": 58548,
	"./svg/users.svg": 2239,
	"./svg/video-dot.svg": 18992,
	"./svg/video-error.svg": 88475,
	"./svg/video-play.svg": 79313,
	"./svg/video.svg": 99414,
	"./svg/warning-circle.svg": 88600,
	"./svg/wine.svg": 88794,
	"./tag-double.svg": 82,
	"./tag.svg": 2532,
	"./thumbs-up.svg": 53031,
	"./trash.svg": 13058,
	"./type.svg": 64612,
	"./upload-cloud.svg": 56587,
	"./upload.svg": 36839,
	"./user-check.svg": 84002,
	"./user-minus.svg": 47966,
	"./user-plus.svg": 14198,
	"./user.svg": 89085,
	"./users.svg": 99476,
	"./video-broke.svg": 64353,
	"./video-dot.svg": 49103,
	"./video-error.svg": 57272,
	"./video-play.svg": 93600,
	"./video.svg": 42949,
	"./warning-circle.svg": 23341,
	"./wine.svg": 80319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7816;